import { Stack  } from "@mui/material"
import { useContext } from "react"
import UserContext from "../../services/Context/UserContext"
import Layout from "../Frames/Layout"
import Top from "./components/Top"
import SponsorContent from "./components/SponsorContent"

export default function Sponsor(){

    const {user} = useContext(UserContext);

    return (
        <Layout tab='profile' menu='main'>
            <Stack spacing={3} sx={{maxWidth: 700, margin: 'auto', mt: 3}}>
                <Top user={user}/>
                <SponsorContent />
            </Stack>
        </Layout>
    );
    
}